import {createContext} from "react";

export const emptyUserView = {
    userId: null,
    presetName: 'Default Preset',
    isActivePreset: true,
    _id: null,
}


export const UserViewsContext = createContext({
    userViews: {
        userViewsPresets: [emptyUserView],
        activePreset: emptyUserView
    },
    setUserViews: (userViews) => {}
})